import React from 'react';
import { Box, Typography } from '@telus-uds/components-web';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const BoldLabel = styled.span`
  & * {
    font-weight: 700 !important;
  }
`;

/**
 * Single view-order detail row: gray label cell on the left, white value cell
 * on the right. Shared across all ViewOrderHeader variants for a consistent look.
 */
const DetailRow = ({ label, value }) => (
  <Box pb={6}>
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '4fr 8fr',
        alignItems: 'stretch',
        border: '1px solid #eaeaea',
        borderRadius: '5px',
        overflow: 'hidden'
      }}
    >
      <div style={{ background: '#f7f7f8', padding: '10px' }}>
        <BoldLabel>
          <Typography variant={{ bold: true, colour: 'brand' }}>
            {label}
          </Typography>
        </BoldLabel>
      </div>
      <div style={{ background: '#ffffff', padding: '10px' }}>
        <Typography>{value}</Typography>
      </div>
    </div>
  </Box>
);

DetailRow.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default DetailRow;
